export default {
  errors: {
    fieldsRequired: 'You should add at least one field.',
  },
};
